module.exports = __webpack_public_path__ + "img/excel_2x.a5550af5.svg";